import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { NotificationService } from './notification.service';
import { TranslateService } from '@ngx-translate/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Injectable({
  providedIn: 'root',
})
export class ClientSideErrorsService {
  private clientErrorSubject: Subject<any>;
  public clientError$: Observable<any>;

  constructor(
    private notificationService: NotificationService,
    private translateService: TranslateService,
  ) {
    this.clientErrorSubject = new BehaviorSubject<any>(null);
    this.clientError$ = this.clientErrorSubject.asObservable();
  }

  public error(error) {
    this.notificationService.error(this.translateService.stream(marker(error)));
    this.clientErrorSubject.next(true);
  }

}
